import {ReactNode} from "react";
import {css, cx} from "@panda/css";

interface Props {
    children: ReactNode;
    isSideBarOpen?: boolean;
}

export const MapSize = ({children, isSideBarOpen}: Props) => {
    return <div className={cx(mapSizeStyle, isSideBarOpen && mapSizeWitchSidebar)}>{children}</div>;
};

const mapSizeStyle = css({
    position: "relative",
    display: "flex",
    width: "100%",
    transition: "margin-right 500ms",
    transitionDelay: "50ms",

    md: {
        mr: 0
    }
});

const mapSizeWitchSidebar = css({
    md: {
        mr: "42%"
    }
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

interface Props {
    children: ReactNode;
    isSideBarOpen?: boolean;
}

export const MapSize = ({children, isSideBarOpen}: Props) => {
    return <div className={cx(mapSizeStyle, isSideBarOpen && mapSizeWitchSidebar)}>{children}</div>;
};

const mapSizeStyle = css({
    position: "relative",
    display: "flex",
    width: "100%",
    transition: "margin-right 500ms",
    transitionDelay: "50ms",

    md: {
        mr: 0
    }
});

const mapSizeWitchSidebar = css({
    md: {
        mr: "42%"
    }
});
